import { render } from "./IntegrationsPage.vue?vue&type=template&id=e400e506"
import script from "./IntegrationsPage.vue?vue&type=script&lang=js"
export * from "./IntegrationsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__